<template>
    <div id="appRoot">
        <template v-if="!$route.meta.public">
          <v-app id="inspire" class="app" >
            <app-drawer class="app--drawer" :drawer="isDrawer" :getrole="role" ></app-drawer>
            <app-toolbar class="app--toolbar" @toggle_sidebar="hideSidebar"></app-toolbar>
            <v-main class="app-content-background">
              <!-- Page Header -->
              <v-container>
                <div class="page-wrapper">
                  <div id="overlay">
                    <div id="overlay-text">
                      <looping-rhombuses-spinner
                        :animation-duration="1500"
                        :size="68"
                        :color="'#ffffff'"/>
                    </div>
                  </div>
                  <router-view></router-view>
                  <v-btn color="indigo"
                    dark
                    small
                    fab
                    class="btn-top d-none"
                  >
                    <v-icon>keyboard_arrow_up</v-icon>
                  </v-btn>
                </div>
              </v-container>
            </v-main>
            <!-- Go to top -->
            <app-fab></app-fab>
            <!-- <v-navigation-drawer
              class="setting-drawer"
              temporary
              right
              v-model="rightDrawer"
              hide-overlay
              fixed
              >
            </v-navigation-drawer> -->
          </v-app>
        </template>
        <template v-else>
          <transition>
            <keep-alive>
              <router-view :key="$route.fullpath"></router-view>
            </keep-alive>
          </transition>
        </template>
        <v-snackbar
          :timeout="3000"
          bottom
          right
          :color="snackbar.color"
          v-model="snackbar.show"
        >
          {{ snackbar.text }}
          <v-btn dark text @click.native="snackbar.show = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import AppDrawer from '@/components/core/AppDrawer';
import AppToolbar from '@/components/core/AppToolbar';
import AppFab from '@/components/core/AppFab';
import PageHeader from '@/components/core/PageHeader';
import { LoopingRhombusesSpinner } from 'epic-spinners'
import helper from '@/helpers'

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    LoopingRhombusesSpinner
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
    isDrawer:true,
    role:null,
  }),
  mounted() {
    this.getUser();
    //if(!this.getAuthUser('email')){
   
        // helper.authUser().then(response => {
        //     this.role_id = response.user.role_id
        //     this.$store.dispatch('SET_USER',response.user);
        // }).catch(err => {

        // });
    //}

    

    // var btn = $('.btn-top');

    // $(window).scroll(function() {
    //   if ($(window).scrollTop() > 200) {
    //     btn.removeClass('d-none');
    //   } else {
    //     btn.addClass('d-none');
    //   }
    // });

    // btn.on('click', function(e) {
    //   e.preventDefault();
    //   $('html, body').animate({scrollTop:0}, '300');
    // });
  },
  created () {
    // AppEvents.forEach(item => {
    //   this.$on(item.name, item.callback);
    // });

    window.getApp = this;
  },
  methods: {
    // getAuthUser(name){
    //    return this.$store.getters.check();
    // },  
    hideSidebar()
    {
        this.isDrawer = !this.isDrawer;
    },


    async getUser(){
      try{
        let res = await axios.post(`api/auth/me`)
        if(res.status == 200){
          this.role = res.data.roles;
          // console.log('Account Type:'+ this.role);  
       }
   }
      catch(err){
          console.log("Api user info fail.",err)  
      }
    }

  }
};
</script>

<style lang="scss" scoped>

  #overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: rgba(0,0,0,.9);
    z-index: 99999;
    visibility: hidden;
  }
  #overlay-text{
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
  }
  .btn-top{
    position: fixed;
    bottom: 10px;
    right: 15px;
    transition: 1.5s;
  }
</style>
